import React from 'react';
import { Box } from '@mui/joy';
import { useTranslation } from 'react-i18next';
import {
    getDocumentMediaSpaHref,
    isDocumentMediaPath,
} from 'src/mtska-frontend-data-provider/redux/downloadDocumentMedia';

const CellUrl = ({ value, type = 'simple' }) => {
    const { t } = useTranslation();

    const href = isDocumentMediaPath(value) ? getDocumentMediaSpaHref(value) : value;

    return (
        <Box className={"list-element-cell cell-" + type}>
            <a href={href} rel="noreferrer" target='_blank'>{value}</a>
        </Box>
    )
}

export default CellUrl
